export default "__VITE_ASSET__pf5eGFor__"